import Price from "./Price";

export default function CartItem({ book, changeQuantity, removeItem }) {
  return (
    <div className="cart__item">
      <div className="cart__book">
        <img src={book.url} alt="book image" className="cart__book--img" />
        <div className="cart__book--info">
          <span className="cart__book--title">{book.title}</span>
          <span className="cart__book--price">
            <Price
              salePrice={book.salePrice}
              originalPrice={book.originalPrice}
              displayMode="and"
            />
          </span>
          <button
            className="cart__book--remove"
            onClick={() => removeItem(book)}
          >
            Remove
          </button>
        </div>
      </div>
      <div className="cart__quantity">
        <input
          type="number"
          value={book.quantity}
          min={0}
          max={99}
          className="cart__input"
          onChange={(event) => changeQuantity(book, event.target.value)}
        />
      </div>
      <div className="cart__total">
        ${(+(book.salePrice || book.originalPrice) * +book.quantity).toFixed(2)}
      </div>
    </div>
  );
}
